var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "st0",
    d: "M92.4,483.4c213.9-93.2,356.5-154.6,427.8-184.3c203.8-84.8,246-99.5,273.6-99.9 c6-0.1,19.7,1.5,28.5,8.5c7.5,6,9.5,14.1,10.4,19.8s2.2,18.8,1.2,28.9c-11,116-58.8,397.4-83,527.4c-10.3,55-30.5,73.3-50.2,75.3 c-42.5,4-75-28.2-116.2-55.2c-64.5-42.2-101.1-68.7-163.7-110c-72.5-47.7-25.5-73.9,15.8-116.8c10.9-11.1,198.5-181.9,202.1-197.5 c0.4-1.9,0.9-9.1-3.4-12.9s-10.6-2.5-15.3-1.5c-6.5,1.5-109.6,69.7-309.4,204.5c-29.3,20.1-55.7,29.9-79.5,29.3 c-26.3-0.6-76.6-14.8-114-27c-45.9-15-82.4-22.9-79.2-48.1C39.6,510.7,57.8,497.2,92.4,483.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.75925f75611b5f08cd25d51ea703fa83.svg";
export { ForwardRef as ReactComponent };